var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ant-form-extra",staticStyle:{"min-height":"0px"}},[(_vm.show)?_c('span',[_vm._v(_vm._s(_vm.text))]):(_vm.loading && !_vm.defaultText)?_c('span',[_c('a-icon',{staticClass:"mr-1",attrs:{"type":"sync","spin":""}}),_c('span',[_vm._v(_vm._s(_vm.$t('common_183')))])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }